/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dashboard_Plannings_Stat_HelpInputs */



/**
* | output |
* | --- |
* | "Average number of hours per room where heating is in comfort mode." |
*
* @param {Dashboard_Plannings_Stat_HelpInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const dashboard_plannings_stat_help = /** @type {((inputs?: Dashboard_Plannings_Stat_HelpInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_Plannings_Stat_HelpInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Average number of hours per room where heating is in comfort mode.")
	return /** @type {LocalizedString} */ ("Nombre d’heures moyen par pièce où le chauffage est en mode confort.")
});